<template>
  <div>
    <span v-if="hidePersonalSections">
      <representatives-form
        :form-model="formModel"
        :required="required"
      ></representatives-form>
    </span>
    <span v-else>
      <company-information-form
        :titles="local.organizationData"
        :form-model="formModel"
        :required="required"
        :validation-required="isValidationRequired"
        :is-view-mode="isViewMode"
        :allow-address-check="allowAddressCheck"
        :check-commercial-register-number-status="checkCommercialRegisterNumberStatus"
      ></company-information-form>

      <company-manager-form
        :title="`${local.organizationData.managerTitle} ( ${partyTypeRole} )`"
        :form-model="formModel"
        :show-more-address-details="showCompanyAddress"
        :allow-address-check="allowAddressCheck"
        :required="required"
        :is-view-mode="isViewMode"
      ></company-manager-form>
      <span v-if="isRepresentative">
        <representatives-form
          :form-model="formModel"
          :required="required"
        ></representatives-form>
      </span>
    </span>
    <!-- <naj-address
      :title="local.titleHeader.addressCorporation"
      :form-model="formModel.placeAddress"
      :required="required"
    ></naj-address> -->
  </div>
</template>

<script>
import CompanyInformationForm from './forms/company-information-form';
import CompanyManagerForm from './forms/company-manager-form';
import RepresentativesForm from './forms/representatives-form.vue';
import { partyTypeEnum, casePartyRoleByIdEnum } from '@/helpers/enum.js';
import { isDefendantOrDefendantRepresentative, isProsecutorOrProsecutorRepresentative } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapGlobalGetters } = createNamespacedHelpers('GlobalModule');
export default {
  inject: ['$validator'],
  components: {
    CompanyInformationForm,
    CompanyManagerForm,
    RepresentativesForm,
  },
  props: [
    'formModel',
    'isRepresentative',
    'required',
    'isViewMode',
    'hidePersonalSections',
    'showMoreAddressDetails',
    'allowAddressCheck',
    'checkCommercialRegisterNumberStatus',
  ],
  data() {
    return {
      partyTypeEnum,
      isProsecutorOrProsecutorRepresentative,
      isDefendantOrDefendantRepresentative,
      isValidationRequired: true,
    };
  },
  computed: {
    ...mapGlobalGetters({ currentUserSocialId: 'socialId' }),
    partyTypeRole() {
      var partyRoleValue =
        this.formModel.casePartyRole !== 0 ? this.formModel.casePartyRole : this.formModel.relatedPartiesInfo[0].casePartyRole;
      return this.local.common.casePartyRoles[casePartyRoleByIdEnum[partyRoleValue]];
    },
    isCurrentUserProsecutorOrProsecutorRepresentative() {
      return this.formModel.socialId === this.currentUserSocialId && this.isProsecutorOrProsecutorRepresentative(this.formModel);
    },
    showCompanyAddress() {
      return (
        (this.showMoreAddressDetails &&
          (this.isCurrentUserProsecutorOrProsecutorRepresentative ||
            this.isDefendantOrDefendantRepresentative(this.formModel))) ||
        !this.isValidationRequired
      );
    },
  },
};
</script>
